import Icon from '@/components/shared/icons'
import { Box, Flex, Image, Span } from '@chakra-ui/react'
import { ReactNode } from 'react'
import MenuRightLayout from '../menu/menu-right'
import { Link } from 'react-router-dom'
import JwtPayload from '@/entities/api/jwt'
import { API_URL } from '@/services/api/keys'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/store/store'
import { handleMenuOpen, handleMenuToggle } from '@/store/features/state'
import NotificationsPopup from '../menu/notifications-modal'

const Layout = ({
	children,
	data,
}: {
	children: ReactNode
	data: JwtPayload
}) => {
	const { imageRefrest, menuOpen, menuToggle } = useSelector(
		(state: RootState) => state.state
	)
	const notifiedActive = useSelector(
		(state: RootState) => state.notifications.notifiedActive
	)
	const dispatch = useDispatch<AppDispatch>()

	return (
		<Flex w='full' position='relative' h='100vh' overflowY='hidden'>
			<MenuRightLayout
				data={data}
				left={menuToggle}
				menu={menuOpen}
				close={() => dispatch(handleMenuOpen())}
				lefting={() => dispatch(handleMenuToggle())}
			/>

			<Flex
				w='full'
				bg='gray.50'
				borderRadius='lg'
				h='full'
				flexDirection='column'
				overflowY='auto'
			>
				<Box
					w='full'
					h='10vh'
					display='flex'
					justifyContent={{
						base: menuOpen ? 'end' : 'space-between',
						xl: 'end',
					}}
					p='4'
					alignItems='center'
					position='relative'
				>
					<Box position='absolute' left={{ base: '10', sm: '6' }}>
						{notifiedActive && (
							<Box
								bg='red.50'
								border='1px solid'
								borderColor='red.200'
								color='red.700'
								px='3'
								py='1'
								fontSize='xs'
								rounded='md'
								fontWeight='medium'
								textAlign='start'
								ml={4}
								whiteSpace='nowrap'
								width='max-content'
								display='flex'
							>
								🔕{' '}
								<Span ml='2' display={{ base: 'none', sm: 'block' }}>
									Da clic en cualquier parte para activar las notificaciones
									sonoras
								</Span>
							</Box>
						)}
					</Box>

					<Box
						display={{ base: menuOpen ? 'none' : 'flex', xl: 'none' }}
						alignContent='center'
					>
						<Icon
							icon='bar'
							size='xl'
							color='black'
							click={() => dispatch(handleMenuOpen())}
						/>
					</Box>

					<Box display='flex' alignItems='center'>
						<NotificationsPopup />
						<Link to='/account'>
							{data?.image?.url && (
								<Image
									key={imageRefrest}
									src={`${API_URL}/${data.image?.url}`}
									ml={6}
									w='5vh'
									h='5vh'
									borderRadius='full'
									cursor='pointer'
									alt='profile'
									loading='lazy'
								/>
							)}
						</Link>
					</Box>
				</Box>

				<Box
					w='full'
					h='calc(100vh - 10vh)'
					overflowY='auto'
					overflowX='hidden'
				>
					{children}
				</Box>
			</Flex>
		</Flex>
	)
}

export default Layout
